// 埋点页面链接：https://stream.jd.com/ddrx/#/requirement/25349
// WARNING!!! 请勿手动修改此文件，如需修改请在子午线平台变更后，执行npm run track-init 
import { eventTrackingUtils } from '@/utils/eventTrack/eventTrackingUtils'
interface IPVTrackParamsRecord {
  /** 我的优惠券 */
MyCoupon_Home: undefined
}

const sendPv = {
  /** PV-我的优惠券 */
MyCoupon_Home: () => {
    eventTrackingUtils.submitPV({page_id:'MyCoupon_Home'});
  },
}

interface IExpoTrackParamsRecord {
  /** 优惠券曝光 */
MyCoupon_Home_CouponExpo: {
/** 优惠券id  */
couponId: string,
/** 优惠券批次号  */
batchId: string,
/** 优惠券使用门槛  */
use_threshold: string,
/** 券类型 1-普通券,2-新人券 */
couponType: | '1'| '2',
/** 优惠券金额  */
couponSave: string}
  /** 无可用优惠券兜底 */
MyCoCoupon_Home_NoAvailable_Expo: undefined
}

const EXPOSURE_RECORD: Readonly<Record<keyof IExpoTrackParamsRecord,string>> = Object.freeze({
/** 优惠券曝光 */
  MyCoupon_Home_CouponExpo:'MyCoupon_Home_CouponExpo',
/** 无可用优惠券兜底 */
  MyCoCoupon_Home_NoAvailable_Expo:'MyCoCoupon_Home_NoAvailable_Expo',
})

interface IClickTrackParamsRecord {
  /** 券历史入口点击 */
MyCoupon_Home_CouponHistory: undefined
  /** 优惠券点击 */
MyCoupon_Home_Coupon: {
/** 优惠券id  */
couponId: string,
/** 优惠券批次号  */
batchId: string,
/** 优惠券使用门槛  */
use_threshold: string,
/** 券类型 1-普通券,2-新人券 */
couponType: | '1'| '2',
/** 点击位置  */
clickPos: string,
/** 优惠券金额  */
couponSave: string}
  /** 券可用入口点击 */
MyCCoupon_Home_CouponAvailable: undefined
}

const sendClickTrack = {
  /** 点击事件上报-券历史入口点击 */
MyCoupon_Home_CouponHistory: () => {
    eventTrackingUtils.submitCL({event_id:'MyCoupon_Home_CouponHistory'});
  },
  /** 点击事件上报-优惠券点击 */
MyCoupon_Home_Coupon: (json_param: IClickTrackParamsRecord['MyCoupon_Home_Coupon']) => {
    eventTrackingUtils.submitCL({event_id:'MyCoupon_Home_Coupon',json_param});
  },
  /** 点击事件上报-券可用入口点击 */
MyCCoupon_Home_CouponAvailable: () => {
    eventTrackingUtils.submitCL({event_id:'MyCCoupon_Home_CouponAvailable'});
  },
}

export {
  EXPOSURE_RECORD,
  sendClickTrack,
  sendPv,
}
export type {
  IExpoTrackParamsRecord,
}